// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"f9f594c4","453":"41e351a4","631":"c92ae18b"}[chunkId] + ".chunk.js";
};